import { makeClientGenerated, makeClientImport, ErrorClientTranslate } from '@/services/import/client/makeClientImport';
import { generatedTemplateClient } from '@/services/import/client/templateClient';
import { makeCommandeGenerated, makeCommandeImport, ErrorCommandeTranslate } from '@/services/import/facture/makeCommandeImport';
import { generatedTemplateFacture } from '@/services/import/facture/templateCommande';
import validationClient from '@/services/tiers/validationTiers';
import validationFacture from '@/services/devisCommandes/validation/validation';
import validationContact from '@/services/tiers/validationContact';
import { generatedTemplateContact } from '@/services/import/contact/templateContact';
import { generatedTemplateContactTiers } from '@/services/import/contact/templateContactTiers';
import { generatedTemplatePatrimoineNomenclature } from '@/services/import/patrimoineNomenclature/templatePatrimoineNomenclature';
import { makeContactGenerated, makeContactImport, ErrorContactTranslate } from '@/services/import/contact/makeContactImport';
import { makeContactTiersGenerated, makeContactTiersImport, ErrorContactTiersTranslate } from '@/services/import/contact/makeContactTiersImport';
import { makePatrimoineNomenclatureGenerated, makePatrimoineNomenclatureImport, ErrorPatrimoineNomenclatureTranslate } from '@/services/import/patrimoineNomenclature/makePatrimoineNomenclatureImport';
import { generatedTemplateCampagne } from '@/services/import/campagne/templateCampagne';
import { generatedTemplateDemandeImpression } from '@/services/import/demandeImpression/templateDemandeImpression';
import { makeCampagneGenerated, makeCampagneImport, ErrorCampagneTranslate } from '@/services/import/campagne/makeCampagneImport';
import { makeDemandeImpressionGenerated, makeDemandeImpressionImport, ErrorDemandeImpressionTranslate } from '@/services/import/demandeImpression/makeDemandeImpressionImport';
import { generatedBonStockFile } from '@/services/import/bonStock/templateBonStock';
import { makeBonStockGenerated, ErrorBonStockTranslate, makeBonStockImport } from '@/services/import/bonStock/makeBonStockImport';
import { generatedTemplateLogoDispositif } from '@/services/import/logoDispositif/templateLogoDispositif';
import { makeLogoDispositifGenerated, ErrorLogoDispositifTranslate, makeLogoDispositifImport } from '@/services/import/logoDispositif/makeLogoDispositifImport';
import generatedTemplateCommandeGenerale from '@/services/import/commande/templateCommandeGenerale';
import { makeCommandeGeneraleGenerated, makeCommandeGeneraleImport, ErrorCommandeGeneraleTranslate } from '@/services/import/commande/makeCommandeGeneraleImport';

export const TYPE_PATRIMOINE = 'patrimoine';
export const TYPE_PATRIMOINE_NOMEMCLATURE = 'patrimoine et nomenclature';
export const TYPE_CLIENT = 'client';
export const TYPE_BAILLEUR = 'bailleur';
export const TYPE_BAIL = 'bail';
export const TYPE_COMMANDE = 'Commande';
export const TYPE_FACTURE = 'Facture';
export const TYPE_CONTACT = 'Contact';
export const TYPE_CONTACT_TIERS = 'Contact Tiers';
export const TYPE_CAMPAGNE = 'Campagne';
export const TYPE_EXPORT_PATRIMOINE = 'patrimoine';
export const TYPE_EXPORT_CLIENT = 'client';
export const TYPE_EXPORT_BAILLEUR = 'bailleur';
export const TYPE_EXPORT_BAIL = 'bail';
export const TYPE_DEMANDE_IMPRESSION = 'Demande Impression';
export const TYPE_BON_STOCK = 'Bon Stock';
export const TYPE_LOGO_DISPOSITIF = 'Logo dispositif';

export const TYPE_IMPORT_DATA = [
  {
    title: 'importDonne.patrimoine.title',
    description: 'importDonne.patrimoine.description',
    templateFile: 'static/templateExcel/patrimoine/templatePatrimoine.xlsx',
    type: TYPE_PATRIMOINE,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
  {
    title: 'importDonne.bailleur.title',
    description: 'importDonne.bailleur.description',
    templateFile: 'static/templateExcel/bailleur/templateBailleur.xlsx',
    type: TYPE_BAILLEUR,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
  {
    title: 'importDonne.bail.title',
    description: 'importDonne.bail.description',
    templateFile: 'static/templateExcel/bail/templateBail.xlsx',
    type: TYPE_BAIL,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
];

export const IMPORT_DATA_TYPE = [
  {
    type: TYPE_CLIENT,
    title: 'importDonne.client.title',
    description: 'importDonne.client.description',
    template: generatedTemplateClient,
    generate: makeClientGenerated,
    generateErrorHandler: ErrorClientTranslate,
    importHandler: makeClientImport,
    importErrorHandler: validationClient,
    hasTest: true,
  },
  {
    type: TYPE_CONTACT,
    title: 'importDonne.contact.title',
    description: 'importDonne.contact.description',
    template: generatedTemplateContact,
    generate: makeContactGenerated,
    generateErrorHandler: ErrorContactTranslate,
    importHandler: makeContactImport,
    importErrorHandler: validationContact,
    hasTest: true,
  },
  {
    type: TYPE_CONTACT_TIERS,
    title: 'importDonne.contactTiers.title',
    description: 'importDonne.contactTiers.description',
    template: generatedTemplateContactTiers,
    generate: makeContactTiersGenerated,
    generateErrorHandler: ErrorContactTiersTranslate,
    importHandler: makeContactTiersImport,
    importErrorHandler: () => {},
    hasTest: true,
  },
  {
    type: TYPE_PATRIMOINE_NOMEMCLATURE,
    title: 'importDonne.patrimoineNomenclature.title',
    description: 'importDonne.patrimoineNomenclature.description',
    template: generatedTemplatePatrimoineNomenclature,
    generate: makePatrimoineNomenclatureGenerated,
    generateErrorHandler: ErrorPatrimoineNomenclatureTranslate,
    importHandler: makePatrimoineNomenclatureImport,
    importErrorHandler: () => {},
    hasTest: true,
  },
  {
    type: TYPE_CAMPAGNE,
    title: 'importDonne.campagne.title',
    description: 'importDonne.campagne.description',
    template: generatedTemplateCampagne,
    generate: makeCampagneGenerated,
    generateErrorHandler: ErrorCampagneTranslate,
    importHandler: makeCampagneImport,
    importErrorHandler: () => {},
    hasTest: false,
  },
  {
    type: TYPE_DEMANDE_IMPRESSION,
    title: 'importDonne.demandeimpression.title',
    description: 'importDonne.demandeimpression.description',
    template: generatedTemplateDemandeImpression,
    generate: makeDemandeImpressionGenerated,
    generateErrorHandler: ErrorDemandeImpressionTranslate,
    importHandler: makeDemandeImpressionImport,
    importErrorHandler: () => {},
    hasTest: false,
  },
  {
    type: TYPE_FACTURE,
    title: 'importDonne.facture.title',
    description: 'importDonne.facture.description',
    template: generatedTemplateFacture,
    generate: makeCommandeGenerated,
    generateErrorHandler: ErrorCommandeTranslate,
    importHandler: makeCommandeImport,
    importErrorHandler: validationFacture,
    hasTest: false,
  },
  {
    type: TYPE_COMMANDE,
    title: 'importDonne.commande.title',
    description: 'importDonne.commande.description',
    template: generatedTemplateCommandeGenerale,
    generate: makeCommandeGeneraleGenerated,
    generateErrorHandler: ErrorCommandeGeneraleTranslate,
    importHandler: makeCommandeGeneraleImport,
    importErrorHandler: validationFacture,
    hasTest: false,
  },
  {
    type: TYPE_BON_STOCK,
    title: 'importDonne.bonStock.title',
    description: 'importDonne.bonStock.description',
    template: generatedBonStockFile,
    generate: makeBonStockGenerated,
    generateErrorHandler: ErrorBonStockTranslate,
    importHandler: makeBonStockImport,
    importErrorHandler: () => {},
    hasTest: true,
  },
  {
    type: TYPE_LOGO_DISPOSITIF,
    title: 'importDonne.logoDispositif.title',
    description: 'importDonne.logoDispositif.description',
    template: generatedTemplateLogoDispositif,
    generate: makeLogoDispositifGenerated,
    generateErrorHandler: ErrorLogoDispositifTranslate,
    importHandler: makeLogoDispositifImport,
    importErrorHandler: () => {},
    hasTest: true,
  },
];

export const TYPE_EXPORT_DATA = [
  {
    title: 'exportDonne.patrimoine.title',
    description: 'exportDonne.patrimoine.description',
    templateFile: 'static/templateExcel/patrimoine/templatePatrimoine.xlsx',
    type: TYPE_EXPORT_PATRIMOINE,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
  {
    title: 'exportDonne.bailleur.title',
    description: 'exportDonne.bailleur.description',
    templateFile: 'static/templateExcel/bailleur/templateBailleur.xlsx',
    type: TYPE_EXPORT_BAILLEUR,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
  {
    title: 'exportDonne.bail.title',
    description: 'exportDonne.bail.description',
    templateFile: 'static/templateExcel/bail/templateBail.xlsx',
    type: TYPE_EXPORT_BAIL,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
  {
    type: TYPE_EXPORT_CLIENT,
    title: 'exportDonne.client.title',
    description: 'exportDonne.client.description',
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    isError: false,
    dataIsReady: false,
  },
];
